'use client';

import React from 'react';
import { Paper, Title, Text } from '@mantine/core';

interface NotificationPreferencesProps {
  preferences: any;
  onChange: (preferences: any) => void;
}

export function NotificationPreferences({ preferences, onChange }: NotificationPreferencesProps) {
  return (
    <Paper shadow="sm" radius="md" p="lg">
      <Title order={4}>Notification Preferences</Title>
      <Text c="dimmed" size="sm">Preference management coming soon</Text>
    </Paper>
  );
}